import { render, staticRenderFns } from "./Waiver.vue?vue&type=template&id=39c3ba1e&scoped=true"
import script from "./Waiver.vue?vue&type=script&lang=js"
export * from "./Waiver.vue?vue&type=script&lang=js"
import style0 from "./Waiver.vue?vue&type=style&index=0&id=39c3ba1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c3ba1e",
  null
  
)

export default component.exports